import React from 'react';
import * as AppConfig from '../AppConfig.json'
import { thumbPath } from '../Helper';
// import { LazyLoadImage } from 'react-lazy-load-image-component';
export const CloudImage = props =>
    <img width="100%" {...props} src={props.src && props.src.includes('https://') ? props.src : `${AppConfig.firebase.storageEndpoint}${encodeURIComponent(props.src)}?alt=media`} />